import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import {CoilResponse} from '../../model/coil-response';
import {UnitConversionUtils} from '../../configurator/unit-conversion-utils';


@Component({
    selector: 'app-coil-response',
    templateUrl: './coil-response.component.html',
    styleUrls: ['./coil-response.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class CoilResponseComponent {

  readonly coilResponse = input.required<CoilResponse>();
  readonly title = input.required<string>();
  readonly metricInput = input.required<boolean>();
  readonly isSureflow = input<boolean>(undefined!);

  getCapacityUnits(): string {
    return UnitConversionUtils.getCapacityUnits(this.metricInput());
  }

  getTemperatureUnits(): string {
    return UnitConversionUtils.getTemperatureUnits(this.metricInput());
  }

  getFlowRateUnits(): string {
    return UnitConversionUtils.getFlowRateUnits(this.metricInput());
  }

  getPressureDropUnits(): string {
    return UnitConversionUtils.getPressureUnits(this.metricInput());
  }

}
